import Avatar from '@sats-group/icons/80/avatar-subtract';
import Tag from '@sats-group/ui-lib/react/tag';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import DynamicImage from '../dynamic-image/dynamic-image';
import List from '../list/list';
import type { ProfileCard as Props } from './profile-cards.types';

const ProfileCard: React.FunctionComponent<Props> = ({
  expertise,
  goals,
  goalsTitle,
  image,
  level,
  name,
  position,
  url,
}) => (
  <a href={url} className="profile-cards__card">
    <div className="profile-cards__intro-wrapper">
      <div className="profile-cards__image">
        {image ? (
          <DynamicImage
            {...image}
            aspectRatio={DynamicImage.aspectRatios.square}
            className="profile-cards__portrait"
            focusArea={DynamicImage.focusAreas.Face}
          />
        ) : (
          <div className="profile-cards__avatar">
            <Avatar />
          </div>
        )}
      </div>
      <div className="profile-cards__description">
        <div className="profile-cards__intro">
          <Text
            className="profile-cards__name"
            elementName="h3"
            size={Text.sizes.large}
            theme={Text.themes.emphasis}
          >
            {name}
          </Text>
          {position ? (
            <Text size={Text.sizes.interface}>{position}</Text>
          ) : null}
        </div>
        {level ? (
          <div className="profile-cards__level">
            <Tag variant="tertiary" border size="interface" text={level} />
          </div>
        ) : null}
      </div>
    </div>

    {expertise?.length || goals?.length ? (
      <div className="profile-cards__details">
        {expertise?.length ? (
          <div className="profile-cards__expertise">
            {expertise.map(item => (
              <div key={item}>
                <Tag variant="secondary" size="interface" text={item} />
              </div>
            ))}
          </div>
        ) : null}

        {goals?.length ? (
          <div className="profile-cards__goals">
            {goalsTitle ? (
              <Text size={Text.sizes.small} tight>
                {goalsTitle}
              </Text>
            ) : null}
            <List className="profile-cards__goals-list">
              {goals.map(item => (
                <div className="profile-cards__goal" key={item}>
                  <Text size={Text.sizes.small}>{item}</Text>
                </div>
              ))}
            </List>
          </div>
        ) : null}
      </div>
    ) : null}
  </a>
);

export default ProfileCard;
